import { useQuery } from '@tanstack/react-query'
import { api } from '@api'

export interface Continent {
  code: string
  nameEn: string
  nameFr: string
  nameEs?: string
  name?: string
}

export function useGetContinents(lang: 'en' | 'fr' | 'es') {
  return useQuery({
    queryKey: ['continents', lang],
    queryFn: async () => {
      const { data } = await api.get<Continent[]>('/continents', { params: { lang } })
      return data
    },
  })
}
